import { useFormContext } from 'react-hook-form'
import { classNames } from 'utils/classNames'

type Props = {
  label: string
  name: string
  required?: boolean
}
export type TagType =
  | 'PROJECT_PERSONAL'
  | 'PROJECT'
  | 'PROJECT_DEVELOPMENT'
  | 'PROJECT_FOUNDATION'
  | 'HUMAN_RESOURCES_BP'
  | 'HUMAN_RESOURCES_P'
  | 'NO_DISTRIBUTION'
  | 'NONE'
export const TagSelector = (props: Props): JSX.Element => {
  const { label, name, required } = props
  const { register } = useFormContext()

  const tagList = [
    { key: 'PROJECT_PERSONAL', value: '案件人材' },
    { key: 'PROJECT', value: '案件' },
    { key: 'PROJECT_DEVELOPMENT', value: '案件（開発）' },
    { key: 'PROJECT_FOUNDATION', value: '案件（基盤）' },
    { key: 'HUMAN_RESOURCES_BP', value: '人材（BP）' },
    { key: 'HUMAN_RESOURCES_P', value: '人材（P）' },
    { key: 'NO_DISTRIBUTION', value: '配信なし' },
    { key: 'NONE', value: '-' }
  ]
  const baseStyle =
    'w-full rounded border border-[#ddd] px-3 py-2 text-sm outline-none'

  return (
    <div className="flex flex-col">
      {label && (
        <label className={'mb-1.5 block text-sm font-medium text-[#555]'}>
          {label}
          {required && <span className={'text-red-500'}>{' *'}</span>}
        </label>
      )}
      <select
        {...register(name)}
        className={classNames([baseStyle, 'focus:border-b-teal-400'])}
      >
        {tagList.map((data) => (
          <option value={data.key} key={data.key}>
            {data.value}
          </option>
        ))}
      </select>
    </div>
  )
}
